import i18n from '@/shared/plugins/vue-i18n';
import { routerAsync } from '@/app-module';
import Message from '@/shared/message/message';

const DEFAULT_ERROR_MESSAGE = 'DEFAULT_ERROR_MESSAGE';

function selectErrorMessage(error) {
    let errorMessage;
    if(Array.isArray(error?.response?.data?.message)) {
        errorMessage = error.response.data.message[0];
    } else {
        errorMessage = error?.response?.data?.message;
    }

    const errorMessageDefined = errorMessage && i18n.te(`ERRORS.${errorMessage.toUpperCase()}`) ? errorMessage : DEFAULT_ERROR_MESSAGE;

    return i18n.t(`ERRORS.${errorMessageDefined.toUpperCase()}`);
}

function selectErrorCode(error) {
    return error?.response?.status || 500;
}

export default class Errors {
    static handle(error) {
        if (process.env.NODE_ENV !== 'production') {
            console.error(selectErrorMessage(error));
            console.error(error);
        }

        // 403/404 are resource-access outcomes, not unexpected server errors:
        // return early (no generic toast, no /500 redirect) and let the calling
        // context decide what to do (e.g. redirect to the 404 page).
        if ([403, 404].includes(selectErrorCode(error))) {
            return;
        }

        const errorCodes = [400, 401, 409, 412, 504, 500];
        const currentErrorCode = selectErrorCode(error);

        if (errorCodes.includes(currentErrorCode)) {
            Message.error(selectErrorMessage(error));
            return;
        }

        //network error
        if (!error.response) {
            Message.error(selectErrorMessage(error));
            return;
        }

        routerAsync().push('/500');
    }

    static errorCode(error) {
        return selectErrorCode(error);
    }

    static selectMessage(error) {
        return selectErrorMessage(error);
    }

    static showMessage(error) {
        Message.error(selectErrorMessage(error));
    }
}
